(function () {
  if (window.__oppoProtectionCleanupLoaded) return;
  window.__oppoProtectionCleanupLoaded = true;

  let isCleaning = false;
  let cleanupTimer = null;

  const originalFetch = window.fetch.bind(window);

  function cartUrl(path) {
    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    return root + path;
  }

  async function fetchCart() {
    const response = await originalFetch(cartUrl("cart.js"), {
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Unable to retrieve cart");
    }

    return response.json();
  }

  async function removeOrphanProtectionPlans() {
    if (isCleaning) return false;

    try {
      const cart = await fetchCart();

      const devicePairIds = new Set();
      const updates = {};

      cart.items.forEach((item) => {
        const props = item.properties || {};

        if (
          props._protection_role === "device" &&
          props._protection_pair_id
        ) {
          devicePairIds.add(props._protection_pair_id);
        }
      });

      cart.items.forEach((item) => {
        const props = item.properties || {};

        if (
          props._protection_role === "protection" &&
          props._protection_pair_id &&
          !devicePairIds.has(props._protection_pair_id)
        ) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) {
        return false;
      }

      isCleaning = true;

      const response = await originalFetch(
        cartUrl("cart/update.js"),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            updates,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Unable to remove protection plan");
      }

      return true;
    } catch (e) {
      console.error(e);
      return false;
    } finally {
      isCleaning = false;
    }
  }

  function scheduleCleanup() {
    clearTimeout(cleanupTimer);

    cleanupTimer = setTimeout(async () => {
      const removed = await removeOrphanProtectionPlans();

      if (removed) {
        location.reload();
      }
    }, 300);
  }

  window.fetch = async function () {
    const response = await originalFetch.apply(window, arguments);

    try {
      const request = arguments[0];

      const url =
        typeof request === "string"
          ? request
          : request && request.url
          ? request.url
          : "";

      if (
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear")
      ) {
        scheduleCleanup();
      }
    } catch (e) {
      console.error(e);
    }

    return response;
  };

  document.addEventListener("DOMContentLoaded", async () => {
    const removed = await removeOrphanProtectionPlans();

    if (removed) {
      location.reload();
    }
  });
})();